import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./ZoomHandler.module.css";
import { CustomIconButton, icon } from "../../../../../../../common/components";
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from "../../../../../../my-review/constants/constants";

import { setScrollTo, setZoom } from "../../../../../slice/notes-pdf/notes-pdf-slice";

const PADDING_OFFSET = 48;

function getZoom(imageWidth, pdfContainerWidth) {
	const currentZoom = Math.floor((pdfContainerWidth / imageWidth) * 10) * 10;
	if (currentZoom < ZOOM_MIN) {
		return ZOOM_MIN;
	}
	if (currentZoom > ZOOM_MAX) {
		return ZOOM_MAX;
	}
	return currentZoom;
}

const ZoomHandler = ({ pdfContainerWidth }) => {
	const zoom = useSelector(({ notesPdf }) => notesPdf.zoom);
	const documentId = useSelector(({ notesSelectedDocument }) => notesSelectedDocument.selectedDocument?.id);
	const pageDimensions = useSelector(({ notesSelectedDocument }) => notesSelectedDocument.pageDimensions);
	const page = useSelector(({ notesPdf }) => notesPdf.page || 0);
	const dispatch = useDispatch();
	const initZoom = useCallback(
		() => {
			if (Array.isArray(pageDimensions) && pdfContainerWidth) {
				const maxHeight = Math.max(...pageDimensions.map((o) => o.height));
				const maxWidth = Math.max(...pageDimensions.map((o) => o.width));
				const finalZoom = getZoom(maxWidth, pdfContainerWidth - PADDING_OFFSET);
				if (maxHeight > 0 && maxWidth > 0) {
					dispatch(setZoom(finalZoom));
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[documentId, pageDimensions, dispatch]
	);
	useEffect(
		() => {
			if (documentId && !zoom) {
				initZoom();
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[documentId, pageDimensions, dispatch]
	);
	const handleZoomIn = () => {
		if (zoom < ZOOM_MAX) {
			dispatch(setZoom(zoom + ZOOM_STEP));
			dispatch(setScrollTo({ y1: 0.01, page: page + 1 }));
		}
	};
	const handleZoomOut = () => {
		if (zoom > ZOOM_MIN) {
			dispatch(setZoom(zoom - ZOOM_STEP));
			dispatch(setScrollTo({ y1: 0.01, page: page + 1 }));
		}
	};
	return (
		<div className={styles.zoom}>
			{documentId && (
				<>
					<CustomIconButton
						disabled={zoom <= ZOOM_MIN}
						icon={icon.aitSearchMinus}
						iconClassName={styles.zoom__btn}
						iconColor="var(--grey-800)"
						size="xs"
						onClick={handleZoomOut}
					/>
					<div>{zoom}%</div>
					<CustomIconButton
						disabled={zoom >= ZOOM_MAX}
						icon={icon.aitSearchPlus}
						iconClassName={styles.zoom__btn}
						iconColor="var(--grey-800)"
						size="xs"
						onClick={handleZoomIn}
					/>
				</>
			)}
		</div>
	);
};

export default ZoomHandler;
